import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=67064622&scoped=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=js"
export * from "./PaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./PaymentHistory.vue?vue&type=style&index=0&id=67064622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67064622",
  null
  
)

export default component.exports